{
    let sticky_el = document.querySelector("[data-sticky]");

    let sticky_observer = new IntersectionObserver(
        (entries) => {
            sticky_el.classList.toggle('is-stuck', !entries[0].isIntersecting);
        },
        {
            threshold: 0,
        }
    );

    let sentinel = document.querySelector(".sentinel");

    if (sentinel !== null) {
        sticky_observer.observe(sentinel);
    }
}
